import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import { CountToDirective } from '../../../editors/count-to-directive/count-to.directive';
import { NgIf, DecimalPipe } from '@angular/common';
import { DurationPipe } from '../../../core/pipes/duration.pipe';

@Component({
    selector: 'app-fax-summary-card',
    template: `
    <div class="dashboard-stats__item" [style.background]="backgroundColor"
         [class.stats-item-active]="filterType == selectedFilterType.action" (click)="onCubicClick($event)">
      <div class="icon-group">
        <i class="material-icons" style="font-size: 40px">{{secondIconClass}}</i>
      </div>
      <h3 class="dashboard-stats__title">
        <span appCountTo [countFrom]="'0'" [countTo]="value" (countToChange)="countToValue = $event">
          <ng-container *ngIf="!showAsDuration">{{countToValue | number:'1.0-0'}}</ng-container>
          <ng-container *ngIf="showAsDuration">{{countToValue | duration}}</ng-container>
        </span>
        <small>{{title}}</small>
      </h3>
    </div>
  `,
    standalone: true,
    imports: [CountToDirective, NgIf, DecimalPipe, DurationPipe]
})
export class FaxSummaryCardComponent implements OnInit, OnDestroy {

  @Input() public backgroundColor: string;
  @Input() public secondIconClass: string;
  @Input() public title: string;
  @Input() public value: number;
  @Input() public showAsDuration = false;

  @Input() selectedFilterType = {action: 99, text: 'Total Calls'};
  @Input() filterType = -1;

  @Output() onClick = new EventEmitter<number>();

  public countToValue = 0;

  constructor() {
  }

  onCubicClick($event) {
    if (this.onClick) {
      this.onClick.emit(this.filterType);
    }
  }

  ngOnInit() {
    console.log('init: ' + FaxSummaryCardComponent.name);
  }

  ngOnDestroy() {
    console.log('destroy: ' + FaxSummaryCardComponent.name);
  }

}
